import React, { useEffect, useRef, useState } from 'react';
import { Button, ConfigProvider, Input, Modal, Space } from 'antd';
import classNames from 'classnames';
import { useRequest } from 'ahooks';
import copy from 'copy-to-clipboard';
import { getApplicationUrl } from '@/const/serviceEnv';
import { CommonStore } from '@/stores';
import { Message, useSeePost } from './useChat';
import Icon from '../Icon';
import { Markdown } from '../Markdown';
import { message } from '../Message';
import './index.less';

interface ChatBoxProps {
  item: Message;
}

function ChatBox({ item }: ChatBoxProps) {
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="message-group">
      <div className="message-box question-box">
        <div className="message-content box-space box-style">{item.question}</div>
      </div>
      <div className="message-box answer-box">
        {item.readNum ? (
          <div className="read-num">
            <Icon type="icon-magic" />
            已阅读{item.readNum}篇文档
          </div>
        ) : null}
        <div className="message-content box-space box-style">
          {item.loading && !item.answer ? (
            <div className="chat-list-item-process">
              <img
                style={{ width: 24, height: 24 }}
                src="https://oss.elebuys.com/resource/goods/materials/202504271415470007772189.gif"
              />
              <span>...</span>
            </div>
          ) : (
            <div ref={contentRef}>
              <Markdown content={item.answer} />
            </div>
          )}
          {!item.loading && (
            <Space className="btns" size={20}>
              {item.regenerate ? (
                <Button onClick={item.regenerate} type="link" size="small">
                  <Icon type="icon-zhongxinshengcheng" />
                  重新生成
                </Button>
              ) : null}
              <Button
                onClick={() => {
                  const success = copy(contentRef.current?.innerText || '');
                  success && message.success('已复制');
                }}
                type="link"
                size="small"
              >
                <Icon type="icon-fuzhi" />
                复制
              </Button>
            </Space>
          )}
        </div>
        {item.suggests?.length ? (
          <div className="ref-docs">
            {item.suggests.map((item) => (
              <div className="ref-doc" key={item.ref_id}>
                <a
                  href={`${getApplicationUrl('help')}/${
                    item.ref_type === 'LEARNING' ? 'learning' : 'article'
                  }/details/${item.ref_id}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item.title} <Icon type="icon-jinru" />
                </a>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

function CustomerServiceByAI() {
  const timerRef = useRef<NodeJS.Timeout>();
  const [animate, setAnimate] = useState(false);
  const [folded, setFolded] = useState(!!localStorage.getItem('ai_ass_fold'));

  const [inputValue, setInputValue] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { chatListDomRef, isChatting, chatList, send, abort } = useSeePost();

  const handleSubmit = (value: string) => {
    if (!value || isChatting) return;
    const sanitizedValue = value.replace(/\n/g, '').trim();
    // 清空输入框
    setInputValue('');
    // 对话开始
    send({ inputMessage: sanitizedValue });
  };

  useEffect(() => {
    if (folded) {
      localStorage.setItem('ai_ass_fold', '1');
    } else {
      localStorage.removeItem('ai_ass_fold');
    }
  }, [folded]);

  useEffect(() => {
    if (!folded) {
      setAnimate(true);
      timerRef.current = setTimeout(() => {
        setAnimate(false);
      }, 5000);
    }
  }, []);

  /* useEffect(() => {
    console.log('chatList', chatList);
  }, [chatList]); */

  return (
    <div className="customer-service-by-ai">
      <ConfigProvider
        theme={{ components: { Tooltip: { colorBgSpotlight: 'var(--primary-color)' } } }}
      >
        <div
          className={classNames('icon-animaion', { folded })}
          style={{ opacity: isModalOpen ? 0 : 1 }}
          onClick={() => {
            folded ? setFolded(false) : setIsModalOpen(true);
          }}
          onMouseEnter={() => {
            clearTimeout(timerRef.current);
            !folded && setAnimate(true);
          }}
          onMouseLeave={() => setAnimate(false)}
        >
          <div
            className={classNames('popover-animaion', { active: animate })}
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={(e) => e.stopPropagation()}
            onMouseLeave={(e) => e.stopPropagation()}
          >
            Hi，我是您的平台AI客服，有什么问题可以向我提问噢～
          </div>
          <img
            className="icon"
            src={
              folded
                ? 'https://oss.elebuys.com/resource/goods/materials/202504271113040007644649.png'
                : 'https://oss.elebuys.com/resource/goods/materials/202504271045370007625684.png'
            }
            alt=""
          />
          <div className="text">AI客服</div>
          <div
            className="flod-icon"
            onClick={(e) => {
              e.stopPropagation();
              clearTimeout(timerRef.current);
              setAnimate(false);
              setFolded(true);
            }}
          >
            <Icon type="icon-zhedie-you" />
          </div>
        </div>
      </ConfigProvider>
      <Modal
        rootClassName="customer-service-by-ai-modal"
        width={544}
        title={null}
        footer={null}
        open={isModalOpen}
        mask={false}
        maskClosable={false}
        onCancel={() => setIsModalOpen(false)}
        afterOpenChange={() => {
          document.body.style.overflow = '';
        }}
      >
        <div className="title">
          <img
            src="https://oss.elebuys.com/resource/goods/materials/202504271042450007622741.png"
            alt=""
          />
          <span>AI客服</span>
        </div>
        <div ref={chatListDomRef} className="content">
          <div className="message-box answer-box">
            <div className="message-content box-space box-style">
              <div style={{ marginBottom: 8, fontSize: 14, fontWeight: 500 }}>
                您好，我是您的AI客服
              </div>
              <div>我汇聚了天猫超市企业购平台的各类帮助文档信息，有什么问题尽管向我提问吧！</div>
            </div>
          </div>
          {/* {[
            {
              messageId: 'a9c95400-9b5d-47b7-941e-bb265c0870f7',
              conversationId: '1e36daab-96a3-47d5-86eb-8d2f5f2b7231',
              question: '订单在哪里看',
              answer:
                '您可以在订单详情中查看您的订单。发货后，包裹的物流信息也会在订单详情页面显示。\n\n![](https://qa-oss.elebuys.com/tmpdir/202504271437110007344888.jpeg)\n\n如果您需要进一步的帮助，比如如何导出订单、服务订单的处理或者订单配置等问题，也可以告诉我，我会提供相应的帮助信息。',
              loading: false,
              error: '',
              suggests: [
                {
                  ref_id: '155',
                  ref_type: 'SUPPORT',
                  title: '分采通操作文档',
                },
              ],
              readNum: 2,
            },
          ].map((item) => (
            <ChatBox item={item} key={item.messageId} />
          ))} */}
          {chatList.map((item) => (
            <ChatBox item={item} key={item.messageId} />
          ))}
        </div>
        <div className="footer">
          <div className="input-wrapper">
            <Input.TextArea
              className="input-textarea"
              value={inputValue}
              onPressEnter={(e: any) => handleSubmit(e.target.value)}
              onChange={(e) => {
                const value = e.target.value.trim();
                e.target.value = value;
                const sanitizedValue = value.replace(/\n/g, '').trim();
                setInputValue(sanitizedValue);
              }}
              placeholder="请输入你的问题"
              maxLength={1000}
              autoSize
            />
            {isChatting ? (
              <button className="send-btn" onClick={abort}>
                <Icon type="icon-tingzhi" />
              </button>
            ) : (
              <button
                className={classNames('send-btn', { disabled: !inputValue })}
                onClick={() => handleSubmit(inputValue)}
                disabled={!inputValue}
              >
                <Icon type="icon-fasong" />
              </button>
            )}
          </div>
          <div className="technical-support">
            <Icon type="icon-logo1" />
            百鲤璇玑提供技术支持
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default function AuthCustomerServiceByAI() {
  const { data: isSHow } = useRequest(async () => {
    return sessionStorage.getItem('test') || CommonStore.getFctAIAssistantAuth();
  });

  if (isSHow) {
    return <CustomerServiceByAI />;
  }

  return null;
}
